import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addLeadStage, getLeadStage, deleteLeadStage, updateLeadStage } from "../../store/settings/Appointment/actions"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    FormGroup,
    Label,
    Input,
    Button,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasBody,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class LeadStage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            leadstage: ''
        }
        this.handleLeadStageSubmit = this.handleLeadStageSubmit.bind(this)
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
    }
    toggleBackdrop() {
        this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
        this.setState(prevState => ({
            deleteModal: !prevState.deleteModal,
        }));
    };
    onClickDelete = (leadstage) => {
        this.setState({ leadstage: leadstage });
        this.setState({ deleteModal: true });
    };

    handleDeleteLeadStage = () => {
        const { onDeleteLeadStage } = this.props;
        const { leadstage } = this.state;

        if (leadstage.id !== undefined) {
            onDeleteLeadStage(leadstage);
            this.setState({ deleteModal: false });
        }
    };
    toggle() {
        this.setState(prevState => ({
            isRight: !prevState.isRight
        }));
    }
    handleLeadStageSubmit(value) {
        this.props.addLeadStage(value, this.props.history);
    }

    componentDidMount() {
        const { onGetLeadStage } = this.props;
        onGetLeadStage(localStorage.getItem('userId'));
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { leadstages } = this.props;
        if (!isEmpty(leadstages) && size(prevProps.leadstages) !== size(leadstages)) {
            this.setState({ leadstages: {}, isEdit: false });
        }
    }
    toggleRightCanvas() {
        this.setState({ leadstage: "", isEdit: false, isRight: !this.state.isRight });
        this.toggle();
    }
    toggleRightCanvas = arg => {
        const leadstage = arg;
        
        this.setState({
            leadstage: {
                id: leadstage.id,
                leadStageTitle: leadstage.leadStageTitle,
                agentId: leadstage.agentId
            },
            isEdit: true,
        });
        this.toggle();
    };
    render() {
        const { leadstages, onUpdateAppLeadStage } = this.props;
        const { isEdit, deleteModal } = this.state;
        const leadstage = this.state.leadstage;
        //
        return (
            <React.Fragment>
                {this.props.loading && this.props.loading ? (
                    <div className="loading">Loading&#8230;</div>
                ) : null}
                <ToastContainer autoClose={2000} />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={this.handleDeleteLeadStage}
                    onCloseClick={() => this.setState({ deleteModal: false })}
                />
                <div className="page-content">
                    <MetaTags>
                        <title>Agent Profile | Realty Space</title>
                    </MetaTags>
                    <Container fluid>


                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}

                                    breadcrumbItem={this.props.t("Lead Stage")}
                                />

                            </Col>

                        </Row>
                        <Row>
                            <Col xl="3">
                                <SettingSidebar />
                            </Col>

                            <Col xl="9">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        leadStageTitle: (this.state && this.state.leadStageTitle) || "",

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadStageTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={this.handleLeadStageSubmit}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >



                                            <Card>
                                                <CardBody>
                                                    <CardTitle className="mb-4">Lead Stage</CardTitle>
                                                    <Row>


                                                        <Col sm="3">
                                                            <FormGroup className="mb-3">
                                                                <Label htmlFor="leadStageTitle">
                                                                    {this.props.t("Title *")}
                                                                </Label>
                                                                <SafeField
                                                                    name="leadStageTitle"
                                                                    onChange={handleChange}

                                                                    type="text"

                                                                    className={
                                                                        "form-control" +
                                                                        (errors.leadStageTitle && touched.leadStageTitle
                                                                            ? " is-invalid"
                                                                            : "")
                                                                    }

                                                                    id="leadStageTitle"
                                                                />
                                                                <ErrorMessage
                                                                    name="leadStageTitle"
                                                                    component="div"
                                                                    className="invalid-feedback"
                                                                />
                                                            </FormGroup>

                                                        </Col>

                                                        <Col sm="2">
                                                            <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                                                        </Col>

                                                    </Row>


                                                </CardBody>
                                            </Card>
                                            <Card>
                                                <CardBody>
                                                    <h5 className="card-title">History</h5>
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                                            <thead className="">
                                                                <tr>
                                                                    <th>#</th>
                                                                    <th>Title</th>


                                                                    <th>Action</th>


                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {map(leadstages, (leadstage, classkey) => (
                                                                    <tr key={"_list_" + classkey}>
                                                                        <th>{classkey + 1}</th>
                                                                        <td>{leadstage.leadStageTitle}</td>
                                                                        <td>
                                                                                {leadstage.agentId > 0 ? (
                                                                            <>
                                                                             <ActionEdit onClick={() => this.toggleRightCanvas(leadstage)} />
                                                                                                                                                                                                                                                                                                                                                                                        
                                                                            <ActionDelete onClick={() => this.onClickDelete(leadstage)} />
                                                                          </>
                                                                        ) : null}

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CardBody>
                                            </Card>








                                        </Form>
                                    )}
                                </Formik>




                            </Col>

                        </Row>
                        <Offcanvas
                            isOpen={this.state.isRight}
                            direction="end"
                            toggle={this.toggleRightCanvas}
                        >
                            <OffcanvasHeader toggle={this.toggleRightCanvas}>
                                Update
                            </OffcanvasHeader>
                            <OffcanvasBody>
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={{
                                        id: leadstage.id,
                                        leadStageTitle: leadstage.leadStageTitle,
                                        agentId: leadstage.agentId

                                    }}
                                    validationSchema={Yup.object().shape({
                                        leadStageTitle: Yup.string().required("This is required"),


                                    })}

                                    onSubmit={values => {

                                        if (isEdit) {
                                            const updateData = {
                                                id: values.id,
                                                leadStageTitle: values.leadStageTitle,
                                                agentId: values.agentId
                                            };
                                            onUpdateAppLeadStage(updateData);
                                        } else {

                                        }
                                        this.toggle();
                                    }}
                                >
                                    {({ errors, touched, values, handleChange, setFieldValue }) => (
                                        <Form
                                            className="needs-validation"
                                        >




                                            <Row>


                                                <Col sm="12">
                                                    <FormGroup className="mb-3">
                                                        <Label htmlFor="leadStageTitle">
                                                            {this.props.t("Title *")}
                                                        </Label>
                                                        <SafeField
                                                            name="leadStageTitle"
                                                            onChange={handleChange}

                                                            type="text"

                                                            className={
                                                                "form-control" +
                                                                (errors.leadStageTitle && touched.leadStageTitle
                                                                    ? " is-invalid"
                                                                    : "")
                                                            }

                                                            id="leadStageTitle"
                                                        />
                                                        <ErrorMessage
                                                            name="leadStageTitle"
                                                            component="div"
                                                            className="invalid-feedback"
                                                        />
                                                    </FormGroup>

                                                </Col>

                                                <Col sm="12">
                                                    <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                                                </Col>

                                            </Row>



                                        </Form>
                                    )}
                                </Formik>
                            </OffcanvasBody>
                        </Offcanvas>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
LeadStage.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.object,
    addLeadStage: PropTypes.func,
    onGetLeadStage: PropTypes.func,
    leadstages: PropTypes.array,
    onDeleteLeadStage: PropTypes.func,
    onUpdateAppLeadStage: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
    {

        leadstages: AppoinmentObject.leadstages,
        loading: AppoinmentObject.loading

    })
const mapDispatchToProps = dispatch => ({

    addLeadStage: (data) => dispatch(addLeadStage(data)),
    onGetLeadStage: (agentId) => dispatch(getLeadStage(agentId)),
    onDeleteLeadStage: (id) => dispatch(deleteLeadStage(id)),
    onUpdateAppLeadStage: (data) => dispatch(updateLeadStage(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeadStage))
